//The user session is the user's logged in data.
// the session is empty if the user is not logged in
// this data also exists in localStorage

import { PrepareApiProcedure } from "../../components/common/utils/prepare-api-procedure";
import { fetchDataFromAPI } from "../../services/api-requests";
import { notificationService } from "../../services/notification-service";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { throwIfEmpty } from "rxjs";
import { UserInfo } from "../../models/user-info";
import { userActions } from "../slices/user-slice";
import { chargerActions } from "../slices/charger-slice";
import { UserSessionAttributes, createUserSession } from "../../models/user-session-model";
import { AppDispatch, RootState } from "..";
import { getDriverPlan } from "./user-actions";
import { storeUserSession } from "../../services/helpers/session-helpers";


export const setSession = (sessionObj: UserSessionAttributes) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        try {
            const current = getState().user.session;
            // Merge with existing session to avoid dropping fields like first_name/last_name
            const merged: UserSessionAttributes = createUserSession({
                ...current,
                ...sessionObj,
            });
            dispatch(userActions.setUserSession({ session: merged }));

            // Persist to AsyncStorage so rehydration retains full fields
            try { await storeUserSession(merged); } catch {}

            // update the driver plan
            dispatch(getDriverPlan());
        } catch (error) {
            console.error(error);
        }
    }   
}

export const clearSession = (userSession: UserSessionAttributes | undefined) => {
    return async (dispatch: AppDispatch) => {
        if(userSession !== undefined){
            try {
                //log out of server
                const apiQuery = PrepareApiProcedure("logout", "POST", 'logout', {
                    username: userSession.username,
                    IpAddress: userSession.IpAddress,
                });
                const loggedOut = await fetchDataFromAPI(apiQuery);
                console.log(loggedOut);
                //clear out the async storage
                await AsyncStorage.clear();
                //clear the user session
                dispatch(userActions.setUserSession(
                    {session: undefined}
                ))
                //clear active charges so ActiveChargeCard disappears immediately
                dispatch(userActions.clearActiveCharges());
                //clear all chargers to prevent stale data
                dispatch(chargerActions.clearAllChargers());
            } catch(error) {
                console.error(error);
            }
        }
    }
}